import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import NewNav from "../components/Navbar/NewNav";
import Nav from "../components/Navbar/Nav";
import { Footer } from "../components/Footer";
import { Loader } from "../components/Loaders/loader";

export const ProtectedLayout = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    setIsLoading(false);
  }, []);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="flex w-full">
        <Nav />
        <main className="overflow-hidden p-4 w-full my-16 md:my-20">
          <Outlet />
        </main>
      </div>
      <Footer />
    </>
  );
};
